export default "__VITE_ASSET__6379e629__"